import { tablesPaymentsTypes } from '../types/Views'

//TODO Agregar Método de tarjeta al final del array para habilitar esa forma de pago
export const listPayments = ['Depósito', 'Sinpe Móvil', 'Tarjeta']
//export const listPayments = ['Tarjeta',]

export const sinppeMovilRows: tablesPaymentsTypes[] = [
  { name: 'Sinpe Móvil', account: '8832-4292' }
]
export const bankRows: tablesPaymentsTypes[] = [
  {
    name: 'BANCO DE COSTA RICA',
    currency: 'Colón',
    account: 'CR68015201001020090215',
    accountIBan: 'CR6801520100102'
  },
  {
    name: 'BANCO NACIONAL DE C.R.',
    currency: 'Colón',
    account: 'CR78015100010012129623',
    accountIBan: 'CR7801510001001'
  },
  {
    name: 'Bac San José',
    currency: 'Colón',
    account: 'CR96010200009125149241',
    accountIBan: 'CR9601020000912514'
  }
]

export interface FormDataModel {
  area: string
  desc: string
  userName: string
  userLastName: string
  payMethod: string
  isColegial: boolean
  bookingDay: string
  hours: Array<string>
  BookingAdmin: boolean
  nroColegial: string
  photoGallery: string[]
  detailsArea: string
  areaType: string
  userNroId: string
  country: number
  countrySelected: number
  selectedSubarea: Record<string, any>
  fullDay?: boolean
  spaces: number
  isWeekend: boolean
  userEmail: string
  userPhone: string
  pickUp: string
  dropOff: string
  pickUpId: string
  dropOffId: string
  stops: Array<{
    location: string
    placeId: string
  }>
  generalObservations: string

  billingMethodCard: {
    cardNumber: string
    cardName: string
    cardExpiry: string
    cardCvc: string
    payMethodLabel: string
  },
  urlProof: string,
  payMethodLabel: string
  proofFile?: File,
}

export const formDataInit: FormDataModel = {
  area: '',
  desc: '',
  userName: '',
  userLastName: '',
  payMethod: 'Tarjeta',
  isColegial: false,
  bookingDay: '',
  hours: [],
  BookingAdmin: false,
  nroColegial: '',
  photoGallery: [],
  detailsArea: '',
  areaType: '',
  userNroId: '',
  countrySelected: 0,
  country: 0,
  selectedSubarea: {},
  fullDay: false,
  spaces: 0,
  isWeekend: false,
  userEmail: '',
  userPhone: '',
  pickUp: '',
  dropOff: '',
  pickUpId: '',
  dropOffId: '',
  stops: [],
  generalObservations: '',
  billingMethodCard: {
    cardNumber: '',
    cardName: '',
    cardExpiry: '',
    cardCvc: '',
    payMethodLabel: ''
  },
  urlProof: '',
  payMethodLabel: '',
  proofFile: undefined,
}

export const cartDataInit = {
  allAmount: 0,
  allBookings: []
}

export const colegialDataInit = {
  name: '',
  phone: '',
  email: '',
  BookingAdmin: false
}

// Definición de tipos
export interface ProcessPaymentType {
  redirect: string
  key: string
  amount: string
  currency: string
  billToFirstName: string
  billToLastName: string
  billToAddress: string
  billToAddress2: string
  billToCity: string
  billToState: string
  billToZipPostCode: string
  billToCountry: string
  billToTelephone: string
  billToEmail: string
  shipToFirstName?: string
  shipToLastName?: string
  shipToAddress?: string
  shipToAddress2?: string
  shipToCity?: string
  shipToState?: string
  shipToZipPostCode?: string
  shipToCountry?: string
  shipToTelephone?: string
  orderNumber: string
  capture: string
  subscription: string
  platform: string
  returnData: string
  hashVersion: string
  url: string
}

export const defaultValuesProcessPayment: ProcessPaymentType = {
  redirect: `${window.location.origin}/approvePayment`,
  key: '',
  amount: '0',
  currency: 'USD',
  billToFirstName: '',
  billToLastName: '',
  billToAddress: '',
  billToAddress2: '',
  billToCity: 'San Jose',
  billToState: 'San Jose',
  billToZipPostCode: '',
  billToCountry: 'CR',
  billToTelephone: '',
  billToEmail: '',
  shipToFirstName: '',
  shipToLastName: '',
  shipToAddress: '',
  shipToAddress2: '',
  shipToCity: 'JS',
  shipToState: 'SJ',
  shipToZipPostCode: '',
  shipToCountry: 'CR',
  shipToTelephone: '',
  orderNumber: '',
  capture: '0',
  subscription: '0',
  platform: 'api',
  returnData: btoa('dXNlcl9pZD0xMg=='),
  hashVersion: 'V2',
  url: ''
}
